<template>
    <div>
      <Bookings v-if="isDriver"/>
    </div>
  </template> 

  <script>
  
  import Bookings from "@/components/drivers/dashboard/Bookings.vue";

  export default {
    name: 'DriverBookings',
    components: { Bookings },
    data() {
      return {}
    },
    computed: {
      isDriver() {
        return this.$store.getters['auth/isDriver'];
      },
      user() {
        return this.$store.getters['auth/getUser'];
      }
    },
    mounted(){
      //fetch everything from here
      if(this.$store.state.booking.driverBookings.length === 0){
        this.$store.dispatch('fetchDriverBookings', this.user.id);
      }
      if(this.$store.state.booking.driverAvailableBookings.length === 0){
        this.$store.dispatch('fetchDriverAvailableBookings', this.user.id);
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  
  </style>